<nz-card>
  
  <div class="row">
    <div class="col-12">
      <button nz-button nzType="primary" (click)="create()">Tạo mới</button>
    </div>
    <!-- <app-search-filter [isSearch]="false" [total]="queryParams.totalItems" (search$)="getValueSearch($event)">
    </app-search-filter> -->
  </div>
  <nz-divider></nz-divider>
  <nz-table #listViewTable [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
    <tr>
      <th>Sản phẩm</th>
      <th>Ngày chia cổ tức</th>
      <th>Số tiền chia</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of listViewTable.data; trackBy: trackId">
      <td>{{item.productId?.name}}</td>
      <td>{{item.dividendDate | date}}</td>
      <td>{{item.dividendAmt | money}}</td>
      <td>
        <button nz-button class="btn-edit" (click)="edit(item.id)" title="Edit"><i nz-icon nzType="edit" nzTheme="outline"></i></button>
        <button nz-button class="btn-delete" (click)="confirmDelete(item)" title="Delete"><i nz-icon nzType="delete" nzTheme="outline"></i></button>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <div class="ant-table-pagination ant-pagination">
    <nz-pagination [nzPageIndex]="queryParams.page" [nzTotal]="queryParams.totalItems" [nzPageSize]="queryParams.size"
                   [nzShowTotal]="rangeTemplate" (nzPageIndexChange)="loadPage($event)"></nz-pagination>
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }} - {{ range[1] }} of {{ queryParams.totalItems }} items
    </ng-template>
  </div>
</nz-card>
